import { PayloadAction } from '@reduxjs/toolkit';
import { AppBundle } from 'api/optimalprint-sdk.d';
import { cloneDeep } from 'lodash';
import { CategoryState, FilterAttributeGroup } from 'store/category/types';

const setCategoryFiltersSelectionReducer = (
  state: CategoryState,
  action: PayloadAction<AppBundle.Api.Response.Category.V3.CategoryDesignsListV3Response.Filters | null | undefined>,
) => {
  if (!action.payload) {
    return;
  }

  [FilterAttributeGroup.attributeFilters, FilterAttributeGroup.tagFilters].forEach((filterGroup) => {
    // deselect current filters
    state.filters?.[filterGroup]?.forEach((attributeFilter) =>
      attributeFilter.options?.forEach((option) => {
        option.isSelected = false;
      }),
    );

    if (!state.filters) {
      state.filters = {
        attributeFilters: [],
        tagFilters: [],
      };
    }

    // set new filters
    action.payload?.[filterGroup]?.forEach((attributeFilter) => {
      // find matching attribute filter in store
      const targetAttributeFilter = state.filters?.[filterGroup]?.find(
        (aF) => aF.typeName === attributeFilter.typeName,
      );
      // if matching attribute filter not found, add one
      if (!targetAttributeFilter) {
        state.filters?.[filterGroup]?.push(cloneDeep(attributeFilter));
        return;
      }

      attributeFilter.options?.forEach((option) => {
        // find matching option
        const targetOption = targetAttributeFilter.options?.find((opt) => opt.value === option.value);
        // if no matching option found, add one option
        if (!targetOption) {
          targetAttributeFilter.options?.push(cloneDeep(option));
          return;
        }
        // if matching option found, set selection status
        targetOption.isSelected = option.isSelected;
      });
    });
  });
};

export default setCategoryFiltersSelectionReducer;
